<template>
    <v-card rounded="0" height=100%>
        <v-img class="menu-entry-header-wrapper" :style="{backgroundColor: '#005AB4'}">
            <v-card-text class="d-flex menu-entry-headline-text justify-center align-center">
                <v-icon class="mdi-icon" color="white">mdi-silverware-fork-knife</v-icon>
                <span style="width: 60vw;">{{ $t("playout.menu.today") }}</span>
            </v-card-text>
        </v-img>
        <div class="meal-wrapper" v-if="menu !== undefined">
            <meal-view v-if="menu.meals[0]" :meal="menu.meals[0]" :menuDescription="'Menu 1'" :small="true"></meal-view>
            <v-row class="menu-entry-empty-text empty-meal d-flex justify-center align-center" v-else-if="menu.meals.length === 0">{{ $t("menu.entry-empty") }}</v-row>
            <v-row v-else class="empty-meal"></v-row>
            <v-divider class="middle-divider meal-divider" :class="{hide: menu.meals.length === 0}"></v-divider>
            <meal-view v-if="menu.meals[1]" :meal="menu.meals[1]" :menuDescription="'Menu 2'" :small="true"></meal-view>
            <v-row v-else class="empty-meal"></v-row>
        </div>
    </v-card>
</template>
<style lang="scss" scoped>
.empty-meal {
    min-height: 20vh;
    height: 20vh;
    max-height: 20vh;
}
.meal-wrapper{
    height: calc(100% - 10vh);
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 6vh 6vw;
}
.meal-divider {
    margin: 2vh 0;
}
.menu-entry-header-wrapper{
    height: 14vh;
}
.menu-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.menu-entry-empty-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.mdi-icon{
    font-size: 9vh !important;
}
.bold {
    font-weight: bold;
}
.hide {
    opacity: 0;
}
</style>
<script>
import moment from 'moment';
export default {
    data() {
        return {
            loading: true,
            now: '',
        }
    },
    created() {
        this.now = moment(moment.now()).format('YYYY-MM-DD');
        this.$store.dispatch({
            type: 'moduleMenus/fetchMenus',
            startDate: this.now,
            endDate: this.now,
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    methods: {
        getMenuForDate(date) {
            return this.menus.filter(menu => {return menu.date === date})[0];
        },
    },
    computed: {
        menus() {
            return this.$store.getters['moduleMenus/menus'];
        },
        menu() {
            return this.getMenuForDate(this.now);
        }
    }
}
</script>
